"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-env browser */

function debounce(fn, time) {
  var timeout = void 0;
  // eslint-disable-next-line shopify/prefer-early-return
  return function () {
    var _this = this,
        _arguments = arguments;

    if (fn) {
      // eslint-disable-next-line prefer-rest-params
      var functionCall = function functionCall() {
        return fn.apply(_this, _arguments);
      };
      clearTimeout(timeout);
      timeout = setTimeout(functionCall, time);
    }
  };
}

exports.default = debounce;